/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportRefreshYoutubePlaylistsMutationResponse, SocialExportRefreshYoutubePlaylistsPathParams, SocialExportRefreshYoutubePlaylists400, SocialExportRefreshYoutubePlaylists401, SocialExportRefreshYoutubePlaylists403, SocialExportRefreshYoutubePlaylists404 } from "../models/SocialExportRefreshYoutubePlaylists";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportRefreshYoutubePlaylists } from "../axios/socialExportRefreshYoutubePlaylists";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportRefreshYoutubePlaylistsMutationKey = () => [{ url: '/social-export/v1/platforms/youtube/:connectionId/playlists/refresh' }] as const

export type SocialExportRefreshYoutubePlaylistsMutationKey = ReturnType<typeof socialExportRefreshYoutubePlaylistsMutationKey>

export function socialExportRefreshYoutubePlaylistsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = socialExportRefreshYoutubePlaylistsMutationKey()
        return mutationOptions<SocialExportRefreshYoutubePlaylistsMutationResponse, ResponseErrorConfig<SocialExportRefreshYoutubePlaylists400 | SocialExportRefreshYoutubePlaylists401 | SocialExportRefreshYoutubePlaylists403 | SocialExportRefreshYoutubePlaylists404>, {connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"]}, TContext>({
          mutationKey,
          mutationFn: async({ connectionId }) => {
            return socialExportRefreshYoutubePlaylists(connectionId, config)
          },
        })

}

/**
 * @description Bypasses cache and fetches fresh playlists from the YouTube API, then caches the result.
 * @summary Refresh YouTube playlists for a connection
 * {@link /social-export/v1/platforms/youtube/:connectionId/playlists/refresh}
 */
export function useSocialExportRefreshYoutubePlaylists<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportRefreshYoutubePlaylistsMutationResponse, ResponseErrorConfig<SocialExportRefreshYoutubePlaylists400 | SocialExportRefreshYoutubePlaylists401 | SocialExportRefreshYoutubePlaylists403 | SocialExportRefreshYoutubePlaylists404>, {connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportRefreshYoutubePlaylistsMutationKey()

          const baseOptions = socialExportRefreshYoutubePlaylistsMutationOptions(config) as UseMutationOptions<SocialExportRefreshYoutubePlaylistsMutationResponse, ResponseErrorConfig<SocialExportRefreshYoutubePlaylists400 | SocialExportRefreshYoutubePlaylists401 | SocialExportRefreshYoutubePlaylists403 | SocialExportRefreshYoutubePlaylists404>, {connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"]}, TContext>
          

          return useMutation<SocialExportRefreshYoutubePlaylistsMutationResponse, ResponseErrorConfig<SocialExportRefreshYoutubePlaylists400 | SocialExportRefreshYoutubePlaylists401 | SocialExportRefreshYoutubePlaylists403 | SocialExportRefreshYoutubePlaylists404>, {connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportRefreshYoutubePlaylistsMutationResponse, ResponseErrorConfig<SocialExportRefreshYoutubePlaylists400 | SocialExportRefreshYoutubePlaylists401 | SocialExportRefreshYoutubePlaylists403 | SocialExportRefreshYoutubePlaylists404>, {connectionId: SocialExportRefreshYoutubePlaylistsPathParams["connectionId"]}, TContext>
      
}